import { NamedProps } from 'react-select';
import { Select } from '@round/whitelabel-ui';
import { CampaignOption } from 'Modules/Plans/Campaigns/hooks/useCampaignSelect';
import styles from './CampaignSelect.module.css';
import { asMoneyWithoutZeros } from 'helpers';
import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import CampaignImage from 'Modules/Plans/Campaigns/components/CampaignImage/CampaignImage';

type Props = NamedProps<CampaignOption>;

const CampaignSelect = (props: Props) => {
    const { getCurrencyById } = useCurrencies();

    return (
        <Select
            {...props}
            menuPortalTarget={null}
            formatOptionLabel={(option, meta) => {
                if (meta.context === 'value') {
                    return option.label;
                }

                const currency = getCurrencyById(option.currency_id);
                const totalAmount = option.cost ?? 0;
                const unallocatedAmount = totalAmount - option.purchase_orders_allocated_amount;

                return (
                    <div className={styles.container}>
                        <CampaignImage
                            className={styles.image}
                            imageUrl={option.project?.image || null}
                            alt={option.brand?.name ?? 'Brand image'}
                            managedBy={option.managed_by ?? null}
                            platform={option.platform}
                        />
                        <div className={styles.labels}>
                            <p className={styles.label}>{option.label}</p>
                            <p className={styles.subLabel}>
                                {option.team?.name ?? '-'} - {option.brand?.name ?? '-'} - {option.project?.name ?? '-'}
                            </p>
                            <p className={styles.amount}>
                                Unallocated:&nbsp;
                                <strong>
                                    <span className={styles.unallocatedAmount}>
                                        {asMoneyWithoutZeros(unallocatedAmount, currency)}
                                    </span>
                                    &nbsp;/&nbsp;
                                    {asMoneyWithoutZeros(totalAmount, currency)}
                                </strong>
                            </p>
                        </div>
                    </div>
                );
            }}
        />
    );
};

export default CampaignSelect;
